import React from 'react'

const Container = ({ children }: { children: React.ReactNode }) => (
  <div className="relative z-10 border-b border-gray-200 pb-4">
    <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">{children}</div>
  </div>
)

export default Container
